import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, FormControl, TextField } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import ColumnSettingsDropdown from './ColumnSettingsDropdown';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0, 0, 1)
  }
}));

const defaultSmartMatchColumn = {
  field: 'smartMatchIncludingCost',
  value: <FormattedMessage id="resourceAllocationUserChartDialog.smartMatch" />
};

export const SMART_MATCH_COLUMN_INDEX = 2;

const ColumnSettingsDialogContent = ({
  isPsaPraaResourceMatchingEnabled,
  isSmartMatchTabSelected,
  dropdownFilteredOptions,
  selectedDialogOptions,
  smartMatchDropdownOptions,
  onOptionChange
}) => {
  const classes = useStyles();
  const intl = useIntl();

  const inputProps = useMemo(
    () => ({
      inputProps: {
        'aria-label': intl.formatMessage({
          id: 'resourceAllocationUserItem.hours'
        })
      }
    }),
    [intl]
  );
  const onColumnTwoChange = useCallback(e => onOptionChange(e, 1), [
    onOptionChange
  ]);
  const onColumnThreeChange = useCallback(e => onOptionChange(e, 2), [
    onOptionChange
  ]);
  const onColumnFourChange = useCallback(e => onOptionChange(e, 3), [
    onOptionChange
  ]);

  const showSmartMatchColumn =
    (isSmartMatchTabSelected && isPsaPraaResourceMatchingEnabled) ||
    !isPsaPraaResourceMatchingEnabled;

  return (
    <FormControl fullWidth>
      <TextField
        variant="standard"
        className={classes.root}
        fullWidth
        disabled
        InputProps={inputProps}
        defaultValue={intl.formatMessage({
          id: 'resourceAllocationUserChartDialog.resource'
        })}
        label={intl.formatMessage({
          id: 'resourceAllocationUserChartDialog.columnOne'
        })}
      />
      <ColumnSettingsDropdown
        className={classes.root}
        options={dropdownFilteredOptions}
        label={intl.formatMessage({
          id: 'resourceAllocationUserChartDialog.columnTwo'
        })}
        value={selectedDialogOptions[1]}
        onChange={onColumnTwoChange}
        selectedOptions={selectedDialogOptions}
      />
      {showSmartMatchColumn && (
        <ColumnSettingsDropdown
          className={classes.root}
          options={smartMatchDropdownOptions}
          label={intl.formatMessage({
            id: 'resourceAllocationUserChartDialog.columnThree'
          })}
          value={
            selectedDialogOptions[SMART_MATCH_COLUMN_INDEX]?.props?.id
              ? selectedDialogOptions[SMART_MATCH_COLUMN_INDEX]
              : defaultSmartMatchColumn
          }
          onChange={onColumnThreeChange}
          selectedOptions={selectedDialogOptions}
          disableClearable
          disabled={smartMatchDropdownOptions.length === 1}
        />
      )}
      <ColumnSettingsDropdown
        options={dropdownFilteredOptions}
        label={intl.formatMessage({
          id: showSmartMatchColumn
            ? 'resourceAllocationUserChartDialog.columnFour'
            : 'resourceAllocationUserChartDialog.columnThree'
        })}
        value={selectedDialogOptions[3]}
        onChange={onColumnFourChange}
        selectedOptions={selectedDialogOptions}
      />
    </FormControl>
  );
};

ColumnSettingsDialogContent.propTypes = {
  isPsaPraaResourceMatchingEnabled: PropTypes.bool.isRequired,
  isSmartMatchTabSelected: PropTypes.bool.isRequired,
  dropdownFilteredOptions: PropTypes.array.isRequired,
  selectedDialogOptions: PropTypes.array.isRequired,
  smartMatchDropdownOptions: PropTypes.array.isRequired,
  onOptionChange: PropTypes.func.isRequired
};

export default ColumnSettingsDialogContent;
